import React from 'react'

import quickAdd_createFolder from "../../../../../app/quick-add/sections/project/form/helpers/create-folder"
import {NavigationMenuInlineAddParams} from "../../menu-add-with-popover/@types"
import NavigationMenuItemInputCommon from "./menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../core/gd/const/project"

type Props = {
    level?      : number
    parentId?   : ID

    params      : NavigationMenuInlineAddParams

    onAdded     : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddFolder"
const debug = false

export default function NavigationMenuItemAddFolder(props: Props) {

    const projectIcon = 'folder'

    const onCommit = async (value?:string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        const project = await quickAdd_createFolder({
            parentProject   : props.parentId,
            name            : value,
            owner           : gd.user.id,
            color           : gd.session.projects.get(props.parentId)?.color,
        }, props.params?.isEmpty)

        gd.goTo(project.url)
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[projectIcon]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}